import { Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React, { PropsWithChildren } from 'react';
import { makeStyles } from 'tss-react/mui';
import { PageSection } from '../../pageSection';
import { DesktopHeaderBanner } from './desktopHeaderBanner';
import { MobileHeaderBanner } from './mobileHeaderBanner';
import { TabletHeaderBanner } from './tabletHeaderBanner';

type HeaderBannerClasses = {
	root?: string;
	image?: string;
	gradient?: string;
	content?: string;
};

export type HeaderBannerProps = PropsWithChildren<{
	img: string | string[];
	onImageLoad?: () => void;
	classes?: HeaderBannerClasses;
}>;

export const HeaderBanner: React.FC<HeaderBannerProps> = (props) => {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.only('xs'));
	const isTablet = useMediaQuery(theme.breakpoints.only('sm'));

	if (isMobile)
		return <MobileHeaderBanner {...props} />;
	else if (isTablet)
		return <TabletHeaderBanner {...props} />;
	else
		return <DesktopHeaderBanner {...props} />;
};

const useStyles = makeStyles({ name: 'HeaderBannerTitle' })(theme => ({
	root: {
		color: '#ffffff',
		[theme.breakpoints.up('sm')]: {
			maxWidth: '337px'
		},
		[theme.breakpoints.up('md')]: {
			maxWidth: '517px'
		}
	}
}));

type TitledHeaderBannerClasses = HeaderBannerClasses & {
	title?: string;
};

export type TitledHeaderBannerProps = HeaderBannerProps & {
	children: string;
	classes?: TitledHeaderBannerClasses;
}

export const TitledHeaderBanner: React.FC<TitledHeaderBannerProps> = (props) => {
	const { children, classes, ...other } = props;
	const { title, ...otherClasses } = classes ?? {};
	const { classes: styles, cx } = useStyles();

	return (
		<HeaderBanner {...other} classes={otherClasses}>
			<PageSection maxDesktopWidth>
				<Typography variant='h1' className={cx(styles.root, title)}>
					{children}
				</Typography>
			</PageSection>
		</HeaderBanner>
	);
};
